import Vue from "vue"
import store from "@/store/"
import VueI18n from "vue-i18n"
import events from "@/bl-events"
import getLocale from "@/utils/locale"
import TrialDurationExplanation from "@/features/trial-duration-explanation/components/trial-duration-explanation"
import "@/modules/load-plans"

Vue.use(VueI18n)

const init = (container, subscriptionPlan, hasReminder) => {
  if (!container) return

  const { ctaCopy, piwikCategory, i18nKey, modifiers } = container.dataset
  let { ctaJsClass, loggedInUserRedirect } = container.dataset

  const modifiersJSON = modifiers && JSON.parse(modifiers)

  const redirectToCheckoutPage = container.dataset.redirectToCheckoutPage === "true"
  const includeReminderStep = container.dataset.includeReminderStep === "true" || hasReminder

  new Vue({
    name: "TrialDurationExplanationInit",
    el: container,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) =>
      h(TrialDurationExplanation, {
        props: {
          ctaCopy,
          ctaJsClass,
          piwikCategory,
          subscriptionPlan,
          redirectToCheckoutPage,
          loggedInUserRedirect,
          includeReminderStep,
          i18nKey,
          modifiers: modifiersJSON
        }
      })
  })
}

const setup = (hasReminder, testCategories) => {
  events.on("plans:ready", ({ plans, canTrial }) => {
    if (!canTrial) {
      return
    }

    const containers = document.querySelectorAll(".vue-trial-duration-explanation")

    if (
      testCategories &&
      (testCategories["webtest-20211029-bw119_trial_reminder"] === "trial_reminder" ||
        testCategories["webtest-20211029-bw119_trial_reminder"] === "trial_reminder_no_monthly")
    ) {
      hasReminder = true
    }

    containers.forEach((container) => {
      const subscriptionPlanDuration = parseInt(container.dataset.subscriptionPlanDuration, 10)

      const subscriptionPlan = plans.find((item) => {
        return item.plan.duration === subscriptionPlanDuration
      })

      if (!subscriptionPlan) {
        return
      }

      init(container, subscriptionPlan.plan, hasReminder, testCategories)
    })
  })
}

export default setup
